import debounce from 'debounce-promise';
import http from '../plugins/http';

export default {
  get: debounce((type, value) => http.get('/fillable', { params: { type, value, sort: 'value' } }), 400)
};
